import React from 'react'
import D3RenderedComp from './D3RenderedComp'
import styled from 'styled-components'
const AxisRenderer = styled(D3RenderedComp)`
  & line {
    stroke: #888;
  }
  & path {
    stroke: #888;
  }
  & text {
    fill: #888;
  }
`

const Axis = ({ dx, dy, axis }) => (
  <AxisRenderer dx={dx} dy={dy}>
    {() => axis}
  </AxisRenderer>
)
//
export default Axis
